module.exports = __webpack_public_path__ + "static/media/Tick.2fb4ec36.svg";